module.exports = __webpack_public_path__ + "static/img/item-7-1-big.2a296b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-7-1-big.png
// module id = +MAK
// module chunks = 2